import {
  Component,
  EnvironmentInjector,
  EventEmitter,
  NgZone,
  OnDestroy,
  OnInit,
  runInInjectionContext,
  inject,
  signal,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { PtsPaymentTerminalService } from 'src/app/shared/services/payment-terminal.service';
import { ChargingStationLocationInfo, PtsPaymentTerminal, UiLogResponse, UiLogSearchEvent } from '../../pts-payment-terminal-model';
import { SnackbarService } from 'ok-angular-shared/components';
import { PageEvent } from '@angular/material/paginator';
import { PagingOptions } from 'src/app/shared/models/paging';
import { BehaviorSubject, firstValueFrom, Subscription } from 'rxjs';
import { Firestore, doc, DocumentReference, DocumentData } from '@firebase/firestore';
import { UiLogCardComponent } from './ui-log-card/ui-log-card.component';
import { TerminalEmulatorDialogComponent } from '../terminal-emulator-dialog/terminal-emulator-dialog.component';
import { PagerBase } from 'src/app/shared/models/pagerBase';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FIRESTORE_INSTANCE } from 'src/app/shared/services/firestore-instance.token';
import { observeDocData } from 'src/app/shared/services/firestore-observables';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'adm-terminal-ui-logs-viewer',
  templateUrl: './terminal-ui-logs-viewer-dialog.component.html',
  styleUrl: './terminal-ui-logs-viewer-dialog.component.scss',
  imports: [UiLogCardComponent, MatDialogModule, MatIconModule, MatButton],
})
export class TerminalUiLogsViewerDialogComponent extends PagerBase implements OnInit, OnDestroy {
  dialogRef = inject<MatDialogRef<TerminalUiLogsViewerDialogComponent>>(MatDialogRef);
  data = inject<{
    paymentTerminal: PtsPaymentTerminal;
  }>(MAT_DIALOG_DATA);
  private ptsPaymentTerminalService = inject(PtsPaymentTerminalService);
  private snackbarService = inject(SnackbarService);
  private firestore = inject<Firestore>(FIRESTORE_INSTANCE);
  private ngZone = inject(NgZone);
  private injector = inject(EnvironmentInjector);
  private dialog = inject(MatDialog);

  paymentTerminal: PtsPaymentTerminal;
  uiLogSearchEvent: UiLogSearchEvent;
  uiLogs = signal<UiLogResponse[]>([]);
  actionLogCount: number;
  currentPage: number;
  pagingOptions: PagingOptions;
  private pageChanged = new EventEmitter<{ pageIndex: number; pageSize: number }>();
  public loading$ = new BehaviorSubject<boolean>(false);
  public subscriptions: Subscription[] = [];
  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }
  async ngOnInit(): Promise<void> {
    this.initPaginator();
    this.paymentTerminal = this.data.paymentTerminal;
    await this.consolidateChargingStationLocationInfo();
    this.payterTerminalCollectionSubscription(this.paymentTerminal.serialNumber);
  }

  async consolidateChargingStationLocationInfo() {
    if (!this.paymentTerminal.chargingStationLocationInfo) {
      const chargingStationLocationInfos = (await firstValueFrom(
        this.ptsPaymentTerminalService.getChargingStationInfoForTerminals([this.paymentTerminal.serialNumber])
      )) as ChargingStationLocationInfo[];
      this.paymentTerminal.chargingStationLocationInfo = chargingStationLocationInfos[0];
    }
  }

  private async getUiLogs() {
    this.loading$.next(true);
    this.uiLogSearchEvent = {
      serialNumber: this.data.paymentTerminal.serialNumber,
      paging: {
        pageIndex: this.currentPage,
        pageSize: this.pagingOptions.pageSize,
        length: 0,
      },
    };
    this.ptsPaymentTerminalService.getUiLogs(this.uiLogSearchEvent).subscribe({
      next: uiLogs => {
        this.uiLogs.set(uiLogs.items.filter(log => log.jsonUi !== '{}'));
        this.loading$.next(false);
      },
      error: err => {
        this.snackbarService.error(err?.error.message);
        this.loading$.next(false);
      },
    });
  }

  public close() {
    this.dialogRef.close();
  }

  public async payterTerminalCollectionSubscription(serialNumber: string) {
    await runInInjectionContext(this.injector, async () => {
      const docRef = doc(this.firestore, `OK/Emsp/PayterTerminals/${serialNumber}`) as DocumentReference<DocumentData>;

      const subscription = observeDocData(docRef, this.ngZone).subscribe({
        next: () => this.getUiLogs(),
      });

      this.subscriptions.push(subscription);
    });
  }

  public onPageChanged(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pagingOptions.pageSize = event.pageSize;
    this.getUiLogs();
    this.pageChanged.emit(event);
  }
  clickButton(callbackUrl) {
    console.warn(callbackUrl);
  }

  private initPaginator(): void {
    this.currentPage = 0;
    this.pagingOptions = {
      pageSize: this.defaultModalPageSize,
      pageSizeOptions: this.modalPageSizes,
    };
  }

  handleTerminalEmulator(paymentTerminal: PtsPaymentTerminal) {
    this.dialog.open(TerminalEmulatorDialogComponent, {
      data: {
        paymentTerminal: paymentTerminal,
      },
      width: '1024px',
      minHeight: '650px',
    });
  }
}
